import { Tag } from "antd";
import { actionsColumn, createdColumn } from "../../constants/objects";
import { dateTimeFormat, numberFormatter } from "../../utils/formatter";
import { getStatusColor } from "../../utils/helpers";
import { sUGX, VIEW } from "../../constants/strings";
import { Actions } from "../../components/buttons/Actions";

export const usePayments = () => {
  // const { contextData } = useAppContext();

  const tableData = (data) => [
    ...data.map((item) => {
      const { timestamp, data } = item || {};
      const { customer, amount, status, app_fee, id } = data || {};
      const { email, phone_number } = customer || {};
      const row = {
        id: `#${id}`,
        amount: numberFormatter(amount),
        app_fee: numberFormatter(app_fee),

        status: (
          <Tag className="capitalize" color={getStatusColor(status)}>
            {status}
          </Tag>
        ),
        email,
        phone_number,
        timestamp: dateTimeFormat(timestamp),
        // region_name: item.region_name,
        // cost: numberFormatter(item.cost),
        // active: (
        //   <GenericSwitch end checked={item.active} docRef={item.docRef} />
        // ),
        actions: <Actions actions={[{ action: VIEW }]} />,
        // onclick: () =>
        //   contextData.showGlobalDrawer({
        //     component: <RegionForm data={item} />,
        //     title: "Update Region",
        //   }),
      };
      return row;
    }),
  ];

  const tableColumns = () => [
    { id: "id", title: "Payment ID", align: "left" },
    { id: "amount", tag: sUGX },
    { id: "app_fee", title: "Charge", tag: sUGX },
    { id: "email" },
    { id: "phone_number" },
    { id: "status" },

    createdColumn,
    actionsColumn,
  ];

  return { tableColumns, tableData };
};
